import request from '@utils/request'
import { Config, ReturnType } from './types'

const getBooks = async (
  action: Config['store']['action'],
  params: any,
  state?: string,
) => {
  try {
    const config: ReturnType = {
      url: 'books',
      method: 'get',
      params,
      config: {
        showErr: true,
        store: {
          action: action ?? 'set',
          key: state ?? 'books',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err.message)
  }
}
const getGenreBooks = async (params: any) => {
  try {
    const config: ReturnType = {
      url: 'books',
      method: 'get',
      params,
      config: {
        showErr: true,
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err.message)
  }
}
const getSpecificUserBooks = async (
  action: Config['store']['action'],
  params: any,
  state?: string,
) => {
  try {
    const config: ReturnType = {
      url: `books/specificUsers`,
      method: 'get',
      params,
      authorization: true,
      config: {
        showErr: true,
        store: {
          action: action ?? 'set',
          key: state ?? 'books',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err.message)
  }
}

const getUserBooks = async (action: Config['store']['action'], params: any) => {
  try {
    const config: ReturnType = {
      url: 'books',
      method: 'get',
      params,
      config: {
        showErr: true,
        store: {
          action: action,
          key: 'userBooks',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err.message)
  }
}
const getBook = async (id: any) => {
  try {
    const config: ReturnType = {
      url: `books/${id}`,
      method: 'get',
      config: {
        showErr: true,
        store: {
          action: 'set',
          key: 'book',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err.message)
  }
}
const createBook = async (data: any) => {
  try {
    const config: ReturnType = {
      url: 'books',
      method: 'post',
      authorization: true,
      data,
      config: {
        showErr: true,
        successMsg: 'Book created successfully!',
        store: {
          action: 'prepend',
          key: 'books',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err.message)
  }
}
const updateBook = async (data: any, id: number, state?: string) => {
  try {
    const config: ReturnType = {
      url: `books/${id}`,
      method: 'patch',
      data,
      authorization: true,
      config: {
        showErr: true,
        successMsg: 'Book updated successfully!',
        store: {
          action: 'update',
          key: state ?? 'books',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err.message)
  }
}
const deleteBook = async (id: any, state?: string) => {
  try {
    const config: ReturnType = {
      url: `books/${id}`,
      method: 'delete',
      authorization: true,
      config: {
        showErr: true,
        successMsg: 'Book deleted successfully!',
        store: {
          action: 'remove',
          key: state ?? 'books',
        },
      },
    }
    const response = await request(config)
    return response
  } catch (err: any) {
    throw new Error(err.message)
  }
}
export default {
  getBooks,
  getBook,
  createBook,
  updateBook,
  deleteBook,
  getUserBooks,
  getSpecificUserBooks,
  getGenreBooks,
}
